const schedules = {
  edit: 'Editar',
  delete: 'Eliminar',
  add_schedule: 'Nuevo Calendario',
  edit_schedule: 'Calendario',
  search_schedules: 'Buscar Calendarios',
  search_schedule: 'Buscar calendario',
  save: 'Guardar',
  update: 'Actualizar',
  cycle_length: 'Longitud del Ciclo ({{days}} días)',
  days_label: 'Días de la semana',
  dow: {
    0: 'Dom',
    1: 'Lun',
    2: 'Mar',
    3: 'Mie',
    4: 'Jue',
    5: 'Vie',
    6: 'Sab',
  },
  schedule_name_placeholder: 'Nombre del calendario',
  cycle_date: 'Fecha Inicio del Ciclo',
  default_start_time: 'Hora de Inicio por Defecto',
  default_end_time: 'Hora de Fin por Defecto',
  date: 'Fecha',
  startTime: 'Hora de inicio',
  endTime: 'Hora de fin',
  custom: 'Personalizado',
  cycle_length_text: 'Duración del Ciclo',
  cycle_1_week: '1 semana',
  cycle_2_weeks: '2 semanas',
  cycle_3_weeks: '3 semanas',
  cycle_4_weeks: '4 semanas',
  cycle_1_day: '1 día',
  cycle_2_days: '2 días',
  cycle_3_days: '3 días',
  cycle_4_days: '4 días',
  cycle_5_days: '5 días',
  cycle_6_days: '6 días',
  custom_modal_msg: 'Selecciona la cantidad de días del ciclo (max 28)',
  confirmation_msg:
    '¿Está seguro de que desea cambiar la duración del ciclo? La configuración actual se perderá',
  date_confirmation_msg:
    '¿Está seguro de que desea cambiar la fecha de inicio del ciclo? La configuración actual se perderá',
  edit_event: 'Editar Evento',
  holidays: {
    include: 'Incluir',
    exclude: 'Excluir',
    drag_and_drop:
      'Arrastra y suelta un día festivo para incluirlo o excluirlo',
    holidays: 'Vacaciones',
    add_new: 'Agregar Nuevo',
    include_description:
      'La duración de las vacaciones se AGREGARÁ al cronograma',
    exlude_description:
      'La duración de las vacaciones será ELIMINADA del cronograma',
  },
  table: {
    schedule_id: 'ID',
    schedule_label: 'CALENDARIOS',
    cycle_length: 'LONGITUD DEL CICLO',
    startdate_label: 'FECHA DE INICIO',
    active_label: 'ESTADO',
  },
  error: {
    hour_format: 'El formato debe ser hh:mm AM/PM',
    start_time: 'La hora de inicio no puede ser después de la hora de fin',
    end_time: 'La hora de fin no puede ser antes de la hora de inicio',
  },
  delete_schedule_confirm:
    '¿Está seguro de que desea eliminar el programa {{name}}?',
  no_content: 'Sin contenido',
  created_successfully: 'Programa creado correctamente',
  updated_successfully: 'Programa actualizado correctamente',
  deleted_successfully: 'Programa eliminado correctamente',
  error_updating: 'Error al actualizar el programa',
};

export default schedules;
